<template>
  <div class="notas">
    <h1 style="text-align: center">Notas</h1>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>